import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Accordion } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Moment from "react-moment";
import ScrollContainer from "react-indiana-drag-scroll";

import PleaseWait from "../Reuseable/PleaseWait";
import arrow1 from "../../assets/image 13 (Traced).png";
import { fetchTrainerEntries } from "../../redux/getReducer/getTrainerEntries";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";
import { Modal } from "react-bootstrap";
import VideoFrame from "../Modal/VideoFrame";
import JockeyDetail from "../Modal/JockeyModal";
import RaceModal from "../Modal/RaceModal";
import { IoMdPlay } from "react-icons/io"; 

const TrainerEntries = ({ id }) => {
    const { data: entriestrainer } = useSelector((state) => state.entriestrainer);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { t } = useTranslation();
    const cookiedata = Cookies.get("i18next");

    const [ShowJockey, setShowJockey] = useState(false);
    const [modaldatasJockey, setmodaldatasJockey] = useState();
    const handleJockeyCloses = () => setShowJockey(false);
    const handleShowJockey = (data) => {
        const jId = data?._id || data;
        if (jId) navigate("/jockey-detail?" + jId);
    };

    const [showRace, setShowRace] = useState(false);
    const [modaldataRace, setmodaldataRace] = useState();
    const handleCloseRace = () => setShowRace(false);
    const handleShowRace = (id) => {
        if (id) navigate("/race-detail?" + id);
    };

    const handleShowHorse = (id) => {
        if (id) navigate("/horse-detail?" + id);
    };

    const [shows, setShows] = useState(false);
    const [modaldatas, setmodaldatas] = useState();
    const handleCloses = () => setShows(false);
    const handleShows = async (data) => {
        setmodaldatas(data);
        await setShows(true);
    };

    useEffect(() => {
        dispatch(fetchTrainerEntries({ id }));
    }, [dispatch, id]);

    const FirstLetter = (data) => data ? data.substring(0, 1) : "";

    function distanceLabel(distance, rank) {
        const DistanceTobeChecked = parseFloat(distance);
        if (DistanceTobeChecked.toFixed(2) > 25) return "Dist";
        else if (DistanceTobeChecked.toFixed(2) == 0.05 && rank < 80) return "SHd";
        else if (DistanceTobeChecked.toFixed(2) == 0.10 && rank < 80) return "Hd";
        else if (DistanceTobeChecked.toFixed(2) == 0.25 && rank < 80) return "Nk";
        else if (DistanceTobeChecked.toFixed(2) == 0.01 && rank < 80) return "Ns";
        else if (DistanceTobeChecked.toFixed(2) == 0.00 && rank < 80) return rank === 1 ? 0 : "Dh";
        else return distance;
    }

    return (
        <div className="trainer-entries-master-wrapper">
            <ScrollContainer className="trainer-entries-scroll-box">
                <div className="trainer-entries-grid-table">
                    
                    <div className="new-tranier-modal-thead-16">
                        <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Horse Name")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div>{t("Link")}</div>
                    </div>

                    {/* --- DIV BASED BODY --- */}
                    <div className="trainer-entries-tbody">
                        {entriestrainer === undefined ? (
                            <div className="text-center py-4"><PleaseWait /></div>
                        ) : !entriestrainer || entriestrainer.length === 0 ? (
                            <div className="text-center py-4">{t("No Entries Found")}</div>
                        ) : (
                            entriestrainer.map((item, i) => {
                                const ground = item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn || item.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                                const rowBg = ground === "Turf" ? "#d4edda" : ground === "Dirt" ? "#f2e6d9" : "#f1f5f9";

                                return (
                                    <div 
                                        key={i} 
                                        className="new-tranier-modal-row-16" 
                                        style={{ backgroundColor: rowBg, color: '#343433' }}
                                    >
                                        <div onClick={() => handleShowRace(item.RaceID)} className="new-tranier-modal-link-white">
                                            <Moment format="DD/MM/YYYY">{item.RaceResultData?.Day}</Moment>
                                        </div>
                                        <div>
                                            {cookiedata === "en" ? item.RaceResultData?.RaceCourseData?.AbbrevEn : item.RaceResultData?.RaceCourseData?.AbbrevAr}({FirstLetter(cookiedata === "en" ? ground : item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameAr)})
                                        </div>
                                        <div className="new-tranier-modal-link-white" onClick={() => handleShowHorse(item.HorseIDData?._id)}>
                                            {cookiedata === "en" ? toTitleCase(item.HorseIDData?.NameEn || "-") : (item.HorseIDData?.NameAr || "-")}
                                        </div>
                                        <div>
                                            {item.RaceResultData?.TrackLengthData?.TrackLength || item.Distance || "-"}
                                        </div>
                                        <div className="new-tranier-modal-truncate">
                                            {cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData?.RaceTypeModelData?.NameEn)) : item.RaceResultData?.RaceTypeModelData?.NameAr}
                                        </div>
                                        <div>{item.RaceTime || "-"}</div>
                                        <div onClick={() => handleShowJockey(item.JockeyOnRaceDataResult?._id)} className="new-tranier-modal-link-white">
                                            {cookiedata === "en" ? toTitleCase(item.JockeyOnRaceDataResult?.ShortNameEn) : item.JockeyOnRaceDataResult?.ShortNameAr}
                                        </div>
                                        <div>{item.JockeyRaceWeight || "-"}</div>
                                        <div>
                                            {item.FinalPositionDataHorse && (cookiedata === "en" ? toTitleCase(item.FinalPositionDataHorse?.NameEn) : item.FinalPositionDataHorse?.NameAr)}
                                        </div>
                                        <div>
                                            {distanceLabel(item.Distance && item.Distance, item.FinalPositionDataHorse && item.FinalPositionDataHorse?.Rank)}
                                        </div>
                                        <div>{item.Runners || "-"}</div>
                                        <div className="new-tranier-modal-truncate new-tranier-modal-link-white" onClick={() => handleShowHorse(item.BeatenByData?._id || item.BeatenByData)}>
                                            {item.BeatenByData ? toTitleCase(cookiedata === "en" ? item.BeatenByData?.NameEn : item.BeatenByData?.NameAr) : toTitleCase(cookiedata === "en" ? item.HorseIDData?.HorseBeatenByEnglishName : item.HorseIDData?.HorseBeatenByArabicName)}
                                        </div>
                                        <div>{item.BeatenByData ? item.BeatenByData.WinningHorseJockeyWeight : (item.HorseIDData?.BeatenByJockeyWeight || 0)}</div>
                                        <div>{item.HorseNo || item.GateNo || "-"}</div>
                                        <div>{item.Rating || 0}</div>
                                        <div onClick={() => handleShows(item.VideoLink)} className="new-tranier-modal-mini-play"><IoMdPlay /></div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </ScrollContainer>
            {/* --- ALL MODALS PRESERVED --- */}
            <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
        </div>
    );
};

export default TrainerEntries;